import configReducer from './config';
import connectedProductReducer from './connected-product';
import facebookReducer from './facebook';
import userReducer from './user';
import paymentReducer from './payment';
import shippingAddressReducer from './shipping-address';
import activateEmailReducer from './activate-email';
import navigationFlow from './navigation-flow';

export default {
  config: configReducer,
  connectedProduct: connectedProductReducer,
  facebook: facebookReducer,
  user: userReducer,
  payment: paymentReducer,
  shippingAddress: shippingAddressReducer,
  activateEmail: activateEmailReducer,
  navigationFlow: navigationFlow,
};
